import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    button: true,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/equipment/' + _ctx.equipment.uuid)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['inner'])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.equipment.display_name), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.equipment.reference), 1),
          (_ctx.lastTracker?.action==='check:out')
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                _createVNode(_component_ion_icon, { icon: _ctx.userIcon }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.lastUser?.display_name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.lastTracker?.action==='check:out'&&_ctx.lastUser)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                _createVNode(_component_ion_icon, { icon: _ctx.pinIcon }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.lastTracker?.site?.display_name), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['right'])
        }, [
          (_ctx.lastTracker?.action)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('equipment.tracker.events.' + _ctx.lastTracker.action)), 1))
            : _createCommentVNode("", true),
          (_ctx.lastTracker)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(_ctx.$style['date'])
              }, _toDisplayString(_ctx.moment(_ctx.lastTracker.tracked_at) > _ctx.moment().subtract(14, 'days') ? _ctx.moment(_ctx.lastTracker.tracked_at).fromNow() : _ctx.moment(_ctx.lastTracker.tracked_at).format('LL')), 3))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['user-pictures'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
              return (_openBlock(), _createElementBlock("img", {
                key: role.user.uuid,
                src: role.user.profile_picture,
                loading: "lazy"
              }, null, 8, _hoisted_4))
            }), 128))
          ], 2)
        ], 2)
      ], 2)
    ]),
    _: 1
  }))
}